import { useState } from "react";
import { Button } from "./Button";
import { Cluster } from "./Cluster";
import "./layout.css";

export interface UserPickerOption {
  id: string;
  display_name: string;
}

export interface UserPickerProps {
  options: UserPickerOption[];
  selected: string[];
  onAdd: (userId: string) => void;
  onRemove: (userId: string) => void;
  disabled?: boolean;
}

export function UserPicker({ options, selected, onAdd, onRemove, disabled }: UserPickerProps) {
  const [choice, setChoice] = useState("");
  const selectedSet = new Set(selected);
  const available = options.filter((o) => !selectedSet.has(o.id));
  const byId = new Map(options.map((o) => [o.id, o.display_name]));

  return (
    <div className="ui-user-picker">
      <Cluster gap={2} align="center">
        <select
          aria-label="Choose a person to share with"
          className="ui-user-picker__select"
          value={choice}
          disabled={disabled || available.length === 0}
          onChange={(e) => setChoice(e.target.value)}
        >
          <option value="">Choose a person…</option>
          {available.map((o) => (
            <option key={o.id} value={o.id}>
              {o.display_name}
            </option>
          ))}
        </select>
        <Button
          type="button"
          variant="secondary"
          disabled={disabled || !choice}
          onClick={() => {
            if (choice) {
              onAdd(choice);
              setChoice("");
            }
          }}
        >
          Add
        </Button>
      </Cluster>
      {selected.length > 0 && (
        <Cluster gap={2} className="ui-user-picker__chips">
          {selected.map((id) => (
            <span key={id} className="ui-user-picker__chip">
              {byId.get(id) ?? "(former member)"}
              <button
                type="button"
                className="ui-user-picker__chip-remove"
                aria-label={`Remove ${byId.get(id) ?? "this person"}`}
                disabled={disabled}
                onClick={() => onRemove(id)}
              >
                ×
              </button>
            </span>
          ))}
        </Cluster>
      )}
    </div>
  );
}
